import { useState } from 'react'
import ModalLevelActivity from 'Components/Molecules/M_VViewer/ModalLevelActivity'
import ModalLevelActivityMovil from 'Components/Molecules/M_VViewer/ModalLevelActivityMovil'
import { Info as InfoIcon } from '@mui/icons-material'
import { styled } from '@mui/material'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { useSelector } from 'react-redux'
import { useMediaQuery } from '@mui/material'

// Green Tooltip
const HtmlTooltip = styled(({ className, ...props }) => (
   <Tooltip disableInteractive {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
     backgroundColor: '#667f00',
     color: "white",
     maxWidth: 220,
     fontSize: theme.typography.pxToRem(12),
     border: '1px solid #fff',
   },
 }));

// Panel izquierdo o de eventos
function EventsPanel () {

   const [ openModal, setOpenModal ] = useState(false);
   const volcanoLevels = useSelector( state => state.volcanoLevels );
   const mobileWidth = useMediaQuery( '(max-width:768px)' ); 

   const handleClickOpen = () => setOpenModal( true );
   const handleClickClose = () => setOpenModal( false );

   return (
	<div className="volcanos-list-levels-container">
		<div className="volcanos-list-levels-title">
			<h3 className="title-list">Estados de alerta volcánica</h3>
			<div className="title-icon">				
            <InfoIcon onClick={ handleClickOpen } />
			</div>
		</div>
		<div className="volcanos-list-levels-icons">
         {
            volcanoLevels?.slice().reverse().map((level) => (
               <div className="modal-level-activity" key={level.index_number}>
                  <HtmlTooltip
                     title={<p>{ level.short_description }</p>}
                     placement="right"
                  >
                     <img onClick={ handleClickOpen } alt="level" src={ level.icon }></img>
                  </HtmlTooltip>
               </div>
            ))
         }
		</div>
      {
         ( mobileWidth ) ? 
            <ModalLevelActivityMovil
               volcanoLevels={ volcanoLevels }
               open={ openModal } 
               handleClose={ handleClickClose } 
            /> :
            <ModalLevelActivity 
               volcanoLevels={ volcanoLevels } 
               open={ openModal } 
               handleClose={ handleClickClose } 
            />
      }
	</div>
   )
}

export default EventsPanel